export class PostFiltroSimulacao {
    idStatus: number;
    dataInicio: Date;
    dataFim: Date;
}